import { Box, styled, Typography } from "@mui/material";

interface PageSubHeaderProps {
  description: string;
  borderColor: string;
}

const HeaderContainer = styled("div")({
  display: "flex",
  flexDirection: "row",
  marginTop: 10,
  marginBottom: 30
});

const PageBlurb = ({ description, borderColor }: PageSubHeaderProps) => {
  return (
    <>
      <HeaderContainer>
        <Box
          display="flex"
          flexDirection="column"
          border="1.5px solid #E0E0E0"
          borderColor={borderColor}
          width="100%"
          borderRadius={3}
          p={2}
        >
          <Typography fontSize={14}>
            {description}
          </Typography>
        </Box>
      </HeaderContainer>
    </>
  );
};

export { PageBlurb };
